<template>
  <div class="boxLittle">
    <!--<div class="navTitle">当前位置：益书宝页面 > 选择模板</div>-->
    <div class="boxLeft">
      <div class="leftsc">
        <div class="leftLogo">
          <img class="jgLogo" :src="touXiang" alt="" v-if="touXiang">
          <img class="jgLogo" src="../../../assets/images/moren.jpeg" alt="" v-else>
          <div class="nikname">{{jgname}}</div>
        </div>

       <div style="min-height: 530px;background: #0a2240;width: 200px;">
         <div class="boxLeftTitle">
           <h3 class="muBan1" :class="{actMb1:isAct === '0'}" @click="toPage('/home/mbzxBanKuai/zyMuBan','自有模板','0')">
             <span class="s1"></span>自有模板</h3>
           <!--<div class="muBan1" >-->
           <!--自有模板-->
           <!--</div>-->
         </div>
         <div class="boxLeftTitle">
           <h3 class="muBan2" :class="{actMb2:isAct !== '0'}"
               @click="toPage('/home/mbzxBanKuai/dyjyMuBan',xitMbtitle,xitMbid)"><span class="s2"></span>系统模板</h3>

           <div class="xtLIst">
             <div class="erjiBox"
                  v-for="item in list"
                  :key="item.id"
             >
               <div class="xtName" @click="item.state = !item.state,SetlistShow(item.id)">
                 <span class="s3"></span>
                 <span class="tit">{{item.title}}</span>
                 <span class="s4" v-show="!item.state "></span>
                 <span class="s5" v-show="item.state"></span>
               </div>
               <div class="sanjiTit" v-show="item.state">
                 <div class="st"
                      v-for="items in item.children"
                      :key="items.id"
                      :class="{col:isAct === items.id}"
                      @click="toPage('/home/mbzxBanKuai/dyjyMuBan',items.title,items.id)"
                 >{{items.title}}
                 </div>
               </div>
             </div>
             <!--<div class="xtName"-->
             <!--v-for="item in list"-->
             <!--:key="item.id"-->
             <!--:class="{col:isAct === item.id}"-->
             <!--@click="toPage('/home/mbzxBanKuai/dyjyMuBan',item.title,item.id)"-->
             <!--&gt;-->
             <!--{{item.title}}-->
             <!--</div>-->
           </div>
         </div>
       </div>

      </div>

    </div>
    <div class="boxRight">
      <router-view @setAct="setAct"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "mbzxBanKuai",
    data() {
      return {
        touXiang: '',
        jgname:'',
        isAct: '0',
        list: [],
        xitMbtitle: '', // 系统模板第一个分类的第一条数据标题
        xitMbid: '', // 系统模板第一个分类的第一条数据id
        listShow: '', // 系统模板分类显示
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.$emit('setIsAct', 2),
        // 系统模板分类列表
        this.getkind()

      this.touXiang = this.user.mthumb
      this.jgname = this.user.mnickname
      if(this.$route.query.spanNum){
        this.spanNum = this.$route.query.spanNum
        this.$router.push({
          path: '/home/mbzxBanKuai/dyjyMuBan',
          query: {
            name: this.xitMbtitle,
            id: this.xitMbid
          }
        })
      }else {
        this.spanNum = 3
      }
    },
    methods: {
      // 系统模板分类列表
      getkind() {
        this.$api.apiAdmin.Getkind({
          mid: this.user.mid,
        }).then(res => {
          res.data.map(item=>{
            item.state = false
          })
          this.list = res.data
          if (res.data[0].children) {
            this.xitMbtitle = res.data[0].children[0].title
            this.xitMbid = res.data[0].children[0].id
          }

        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      setAct(isAct) {
        this.isAct = Number(isAct)
      },
      // 设置系统分类显示
      SetlistShow(id){
        if(this.listShow === id){
          this.listShow = 0
        }else {
          this.listShow = id
        }
      },
      toPage(path, name, id) {
        this.isAct = id
        if(id !== 0){
          this.listShow = this.list[0].id
        }
        this.$router.push({
          path: path,
          query: {
            name: name,
            id: id
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .col {
    color: #fc7802 !important;
  }

  .boxLittle {
    width: 1220px;
    margin: 0 auto;
    height: 100%;
    position: relative;
    margin-top: -40px;

    .navTitle {
      width: 100%;
      height: 40px;
      line-height: 40px;
      color: #ffffff;
      font-size: 14px;
    }

    .boxLeft {
      width: 200px;
      position: absolute;
      top: 40px;
      left: 0;
      bottom: 0;
      overflow: hidden;
      background-color: rgba(255, 255, 255, .2);
      /*z-index: 11;*/
      .leftsc {
        width: 217px;
        height: 100%;
        padding-right: 17px;
        padding-bottom: 20px;
        overflow-y: scroll;
        overflow-x: hidden;
        .leftLogo {
          width: 200px;
          height: 230px;
          padding-top: 40px;
          background-color: #0a2240;
          border-radius: 4px;
          margin-bottom: 10px;

          .jgLogo {
            display: block;
            width: 85px;
            height: 85px;
            margin: 0 auto;
            border-radius: 42px;
          }

          .nikname {
            width: 130px;
            margin: 10px auto;
            font-size: 14px;
            color: #ffffff;
            text-align: center;
          }
        }

        .boxLeftTitle {
          width: 200px;
          background: #0a2240;

          h3 {
            height: 30px;
            line-height: 30px;
            font-size: 20px;
            color: #fff;

            .s2 {
              display: inline-block;
              width: 20px;
              height: 20px;
              margin-right: 6px;
              position: relative;
              top: 4px;
              background: url("../../../assets/images/xitong.png") no-repeat center center;
            }

            .s1 {
              display: inline-block;
              width: 15px;
              height: 19px;
              margin-right: 8px;
              position: relative;
              top: 4px;
              background: url("../../../assets/images/ziyou.png") no-repeat center center;
            }
          }

          .muBan1 {
            height: 60px;
            width: 200px;
            cursor: pointer;
            line-height: 60px;
            font-size: 18px;
            color: #fff;
            padding-left: 25px;
            cursor: pointer;
          }

          .muBan2 {
            height: 60px;
            width: 200px;
            cursor: pointer;
            line-height: 60px;
            font-size: 18px;
            color: #fff;
            padding-left: 22px;
          }

          .actMb1 {
            height: 60px;
            width: 200px;
            background: red;
            cursor: pointer;
            line-height: 60px;
            font-size: 18px;
            color: #fff;
            padding-left: 25px;
            background: rgba(255,255,255,.3);
            cursor: pointer;
          }

          .actMb2 {
            height: 60px;
            width: 200px;
            background: red;
            cursor: pointer;
            line-height: 60px;
            font-size: 18px;
            color: #fff;
            padding-left: 22px;
            background: rgba(255,255,255,.3);
          }

          .xtLIst {
            width: 100%;

            .erjiBox {
              width: 100%;

              .xtName {
                width: 100%;
                padding: 10px 0px 0px 25px;
                font-size: 16px;
                height: 40px;
                color: #ffffff;
                cursor: pointer;

                .s3 {
                  float: left;
                  width: 18px;
                  height: 21px;
                  margin-right: 8px;
                  position: relative;
                  top: 4px;
                  background: url("../../../assets/images/wjWhite.png") no-repeat center center;
                }

                .s4 {
                  float: right;
                  width: 18px;
                  height: 21px;
                  margin-right: 8px;
                  position: relative;
                  top: 4px;
                  background: url("../../../assets/images/jiahao.png") no-repeat center center;

                }

                .tit {
                  float: left;
                  width: 120px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  margin-top: 3px;
                }

                .s5 {
                  float: right;
                  width: 18px;
                  height: 21px;
                  margin-right: 8px;
                  position: relative;
                  top: 4px;
                  background: url("../../../assets/images/jianhao.png") no-repeat center center;
                }
              }

              .sanjiTit {
                width: 100%;
                .st {
                  width: 100%;
                  padding: 10px 10px 10px 60px;
                  font-size: 14px;
                  color: #ffffff;
                  cursor: pointer;
                }
              }
            }
          }

        }
      }
    }

    .boxRight {
      position: absolute;
      top: 40px;
      left: 220px;
      right: 0;
      width: 980px;
      bottom: 0;
      background-color: #fff;
      overflow: hidden;
    }
  }
</style>
